import React, { useState } from 'react';
import { DownloadIcon, CalendarIcon, ChevronDownIcon } from 'lucide-react';
import { MetricCard } from '../components/MetricCard';
import { LineChart } from '../components/charts/LineChart';
import { PieChart } from '../components/charts/PieChart';
import { ViewAllButton } from '../components/ViewAllButton';
export const ProcessingAnalytics: React.FC = () => {
  const timeRanges = ['12 months', '3 months', '30 days', '7 days', 'Today'];
  const processingVolumeData = Array.from({
    length: 12
  }, (_, i) => ({
    month: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'][i],
    value: 400 + Math.random() * 400
  }));
  const topServices = [{
    service: 'Passport Application',
    volume: 31256,
    processingTime: '2.4 days',
    slaCompliance: 94,
    trend: 5
  }, {
    service: 'Vehicle Tax Renewal',
    volume: 24563,
    processingTime: '1.2 days',
    slaCompliance: 98,
    trend: -4
  }, {
    service: 'Driving License Renewal',
    volume: 21387,
    processingTime: '4.8 days',
    slaCompliance: 82,
    trend: 6
  }, {
    service: 'Business Registration',
    volume: 18752,
    processingTime: '3.7 days',
    slaCompliance: 88,
    trend: 8
  }, {
    service: 'Birth Certificate',
    volume: 15236,
    processingTime: '1.8 days',
    slaCompliance: 95,
    trend: 8
  }];
  const departments = [{
    name: 'Market',
    efficiency: 96,
    trend: 5,
    volume: 46492,
    processingTime: '1.4 days'
  }, {
    name: 'Land',
    efficiency: 91,
    trend: -4,
    volume: 34628,
    processingTime: '3.2 days'
  }, {
    name: 'Health',
    efficiency: 89,
    trend: 6,
    volume: 27843,
    processingTime: '2.8 days'
  }, {
    name: 'Education',
    efficiency: 86,
    trend: 8,
    volume: 22631,
    processingTime: '4.5 days'
  }, {
    name: 'Civil Registry',
    efficiency: 84,
    trend: 8,
    volume: 15472,
    processingTime: '3.5 days'
  }];
  const submissionChannelData = [{
    name: 'Self-Service',
    value: 68
  }, {
    name: 'Officer-Assisted',
    value: 32
  }];
  const [selectedAgency, setSelectedAgency] = useState('all');
  const [selectedRegion, setSelectedRegion] = useState('all');
  const [selectedZone, setSelectedZone] = useState('all');
  const [selectedWoreda, setSelectedWoreda] = useState('all');
  const [selectedKebele, setSelectedKebele] = useState('all');
  const handleViewAllServices = () => {
    console.log('View all services clicked');
    alert('View all services functionality would be implemented here');
  };
  const handleViewAllDepartments = () => {
    console.log('View all departments clicked');
    alert('View all departments functionality would be implemented here');
  };
  return <div data-id="element-145">
      <div className="flex justify-between items-center mb-6" data-id="element-146">
        <div className="flex-1" data-id="element-147">
          <h2 className="text-xl font-semibold text-gray-800 mb-4" data-id="element-148">
            Processing Analytics
          </h2>
          <div className="flex items-center space-x-4" data-id="element-149">
            <div className="relative" data-id="element-150">
              <select className="appearance-none bg-white border border-gray-200 rounded-md pl-3 pr-8 py-2 text-sm text-gray-600 focus:outline-none focus:ring-2 focus:ring-blue-500" value={selectedAgency} onChange={e => setSelectedAgency(e.target.value)} data-id="element-151">
                <option value="all" data-id="element-152">All Agencies</option>
                <option value="transportation" data-id="element-153">Transportation</option>
                <option value="immigration" data-id="element-154">Immigration</option>
                <option value="civil" data-id="element-155">Civil Registry</option>
                <option value="business" data-id="element-156">Business</option>
              </select>
              <ChevronDownIcon size={16} className="absolute right-2 top-1/2 transform -translate-y-1/2 text-gray-400 pointer-events-none" data-id="element-157" />
            </div>
            <div className="relative" data-id="element-158">
              <select className="appearance-none bg-white border border-gray-200 rounded-md pl-3 pr-8 py-2 text-sm text-gray-600 focus:outline-none focus:ring-2 focus:ring-blue-500" value={selectedRegion} onChange={e => setSelectedRegion(e.target.value)} data-id="element-159">
                <option value="all" data-id="element-160">All Regions</option>
                <option value="amhara" data-id="element-161">Amhara</option>
                <option value="oromia" data-id="element-162">Oromia</option>
                <option value="tigray" data-id="element-163">Tigray</option>
                <option value="snnpr" data-id="element-164">SNNPR</option>
              </select>
              <ChevronDownIcon size={16} className="absolute right-2 top-1/2 transform -translate-y-1/2 text-gray-400 pointer-events-none" data-id="element-165" />
            </div>
            <div className="relative" data-id="element-166">
              <select className="appearance-none bg-white border border-gray-200 rounded-md pl-3 pr-8 py-2 text-sm text-gray-600 focus:outline-none focus:ring-2 focus:ring-blue-500" value={selectedZone} onChange={e => setSelectedZone(e.target.value)} data-id="element-167">
                <option value="all" data-id="element-168">All Zones</option>
                <option value="north" data-id="element-169">North Zone</option>
                <option value="south" data-id="element-170">South Zone</option>
                <option value="east" data-id="element-171">East Zone</option>
                <option value="west" data-id="element-172">West Zone</option>
              </select>
              <ChevronDownIcon size={16} className="absolute right-2 top-1/2 transform -translate-y-1/2 text-gray-400 pointer-events-none" data-id="element-173" />
            </div>
            <div className="relative" data-id="element-174">
              <select className="appearance-none bg-white border border-gray-200 rounded-md pl-3 pr-8 py-2 text-sm text-gray-600 focus:outline-none focus:ring-2 focus:ring-blue-500" value={selectedWoreda} onChange={e => setSelectedWoreda(e.target.value)} data-id="element-175">
                <option value="all" data-id="element-176">All Woredas</option>
                <option value="woreda1" data-id="element-177">Woreda 01</option>
                <option value="woreda2" data-id="element-178">Woreda 02</option>
                <option value="woreda3" data-id="element-179">Woreda 03</option>
                <option value="woreda4" data-id="element-180">Woreda 04</option>
              </select>
              <ChevronDownIcon size={16} className="absolute right-2 top-1/2 transform -translate-y-1/2 text-gray-400 pointer-events-none" data-id="element-181" />
            </div>
            <div className="relative" data-id="element-182">
              <select className="appearance-none bg-white border border-gray-200 rounded-md pl-3 pr-8 py-2 text-sm text-gray-600 focus:outline-none focus:ring-2 focus:ring-blue-500" value={selectedKebele} onChange={e => setSelectedKebele(e.target.value)} data-id="element-183">
                <option value="all" data-id="element-184">All Kebeles</option>
                <option value="kebele1" data-id="element-185">Kebele 01</option>
                <option value="kebele2" data-id="element-186">Kebele 02</option>
                <option value="kebele3" data-id="element-187">Kebele 03</option>
                <option value="kebele4" data-id="element-188">Kebele 04</option>
              </select>
              <ChevronDownIcon size={16} className="absolute right-2 top-1/2 transform -translate-y-1/2 text-gray-400 pointer-events-none" data-id="element-189" />
            </div>
            <div className="flex items-center space-x-2" data-id="element-190">
              <button onClick={() => {
              setSelectedAgency('all');
              setSelectedRegion('all');
              setSelectedZone('all');
              setSelectedWoreda('all');
              setSelectedKebele('all');
            }} className="px-4 py-2 text-sm text-gray-600 border border-gray-200 rounded-md hover:bg-gray-50 transition-colors duration-200" data-id="element-191">
                Clear Filters
              </button>
              <button onClick={() => {
              console.log('Applying filters:', {
                agency: selectedAgency,
                region: selectedRegion,
                zone: selectedZone,
                woreda: selectedWoreda,
                kebele: selectedKebele
              });
            }} className="px-4 py-2 text-sm text-white bg-blue-500 rounded-md hover:bg-blue-600 transition-colors duration-200" data-id="element-192">
                Apply Filters
              </button>
            </div>
          </div>
        </div>
      </div>
      <div className="mb-6" data-id="element-193">
        <div className="flex space-x-4 mb-6" data-id="element-194">
          {timeRanges.map(range => <button key={range} className={`px-4 py-2 text-sm rounded-md ${range === '30 days' ? 'bg-blue-50 text-blue-600' : 'text-gray-600 hover:bg-gray-100'}`} data-id="element-195">
              {range}
            </button>)}
        </div>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-8" data-id="element-196">
        <MetricCard title="Applications Submitted" value="138,672" change={{
        value: '+7.2%',
        positive: true
      }} footer={<a href="#" className="text-blue-500 text-sm" data-id="element-198">
              Download report
            </a>} data-id="element-197" />
        <MetricCard title="Applications Processed" value="124,584" change={{
        value: '+5.3%',
        positive: true
      }} footer={<a href="#" className="text-blue-500 text-sm" data-id="element-200">
              Download report
            </a>} data-id="element-199" />
        <MetricCard title="Backlog" value="197,447" change={{
        value: '-2.5%',
        positive: true
      }} footer={<a href="#" className="text-blue-500 text-sm" data-id="element-202">
              Download report
            </a>} data-id="element-201" />
        <MetricCard title="Average Processing Time" value="3.2 days" change={{
        value: '-0.5 days',
        positive: true
      }} footer={<a href="#" className="text-blue-500 text-sm" data-id="element-204">
              Download report
            </a>} data-id="element-203" />
      </div>
      <div className="bg-white rounded-lg shadow-sm p-6 mb-8" data-id="element-205">
        <div className="flex justify-between items-center mb-6" data-id="element-206">
          <h3 className="text-lg font-medium" data-id="element-207">
            Top Services by Processing Volume
          </h3>
          <ViewAllButton onClick={handleViewAllServices} data-id="element-208" />
        </div>
        <div className="overflow-x-auto" data-id="element-209">
          <table className="min-w-full" data-id="element-210">
            <thead data-id="element-211">
              <tr className="text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-212">
                <th className="px-6 py-3" data-id="element-213">Service</th>
                <th className="px-6 py-3" data-id="element-214">Volume</th>
                <th className="px-6 py-3" data-id="element-215">Avg. Processing Time</th>
                <th className="px-6 py-3" data-id="element-216">SLA Compliance</th>
                <th className="px-6 py-3" data-id="element-217"></th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-200" data-id="element-218">
              {topServices.map(service => <tr key={service.service} data-id="element-219">
                  <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900" data-id="element-220">
                    {service.service}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500" data-id="element-221">
                    {service.volume.toLocaleString()}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500" data-id="element-222">
                    {service.processingTime}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap" data-id="element-223">
                    <div className="flex items-center" data-id="element-224">
                      <div className="w-full bg-gray-200 rounded-full h-2.5 mr-2" data-id="element-225">
                        <div className={`h-2.5 rounded-full ${service.slaCompliance >= 95 ? 'bg-green-500' : service.slaCompliance >= 85 ? 'bg-blue-500' : 'bg-yellow-500'}`} style={{
                      width: `${service.slaCompliance}%`
                    }} data-id="element-226"></div>
                      </div>
                      <span className="text-sm font-medium" data-id="element-227">
                        {service.slaCompliance}%
                      </span>
                      <span className={`ml-2 text-xs ${service.trend > 0 ? 'text-green-500' : 'text-red-500'}`} data-id="element-228">
                        {service.trend > 0 ? '+' : ''}
                        {service.trend}%
                      </span>
                    </div>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-blue-500" data-id="element-229">
                    <a href="#" data-id="element-230">View Details</a>
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>
      </div>
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 mb-8" data-id="element-231">
        <div className="bg-white rounded-lg shadow-sm p-6" data-id="element-232">
          <div className="flex justify-between items-center mb-6" data-id="element-233">
            <h3 className="text-lg font-medium" data-id="element-234">Processing Volume Trends</h3>
            <button className="text-blue-600 bg-white border border-gray-200 px-4 py-1.5 rounded-md text-sm" data-id="element-235">
              View Report
            </button>
          </div>
          <div className="mb-4" data-id="element-236">
            <div className="flex space-x-4" data-id="element-237">
              {timeRanges.map(range => <button key={range} className={`px-4 py-1.5 text-sm rounded-md ${range === '12 months' ? 'bg-blue-50 text-blue-600' : 'text-gray-600 hover:bg-gray-100'}`} data-id="element-238">
                  {range}
                </button>)}
            </div>
          </div>
          <LineChart data={processingVolumeData} xKey="month" yKey="value" data-id="element-239" />
        </div>
        <div className="bg-white rounded-lg shadow-sm p-6" data-id="element-240">
          <div className="flex justify-between items-center mb-6" data-id="element-241">
            <h3 className="text-lg font-medium" data-id="element-242">
              Breakdown by Submission Channel
            </h3>
          </div>
          <div className="mb-4" data-id="element-243">
            <div className="flex space-x-4" data-id="element-244">
              <button className="px-4 py-1.5 text-sm rounded-md bg-blue-50 text-blue-600" data-id="element-245">
                12 months
              </button>
              <button className="px-4 py-1.5 text-sm rounded-md text-gray-600 hover:bg-gray-100" data-id="element-246">
                30 days
              </button>
              <button className="px-4 py-1.5 text-sm rounded-md text-gray-600 hover:bg-gray-100" data-id="element-247">
                7 days
              </button>
              <button className="px-4 py-1.5 text-sm rounded-md text-gray-600 hover:bg-gray-100" data-id="element-248">
                24 hours
              </button>
            </div>
          </div>
          <PieChart data={submissionChannelData} nameKey="name" dataKey="value" colors={['#2563eb', '#60a5fa']} data-id="element-249" />
        </div>
      </div>
      <div className="bg-white rounded-lg shadow-sm p-6" data-id="element-250">
        <div className="flex justify-between items-center mb-6" data-id="element-251">
          <h3 className="text-lg font-medium" data-id="element-252">
            Processing Duration by Department
          </h3>
          <ViewAllButton onClick={handleViewAllDepartments} data-id="element-253" />
        </div>
        <div className="overflow-x-auto" data-id="element-254">
          <table className="min-w-full" data-id="element-255">
            <thead data-id="element-256">
              <tr className="text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-257">
                <th className="px-6 py-3" data-id="element-258">Department</th>
                <th className="px-6 py-3" data-id="element-259">Processing Efficiency</th>
                <th className="px-6 py-3" data-id="element-260">Volume</th>
                <th className="px-6 py-3" data-id="element-261">Avg. Processing Time</th>
                <th className="px-6 py-3" data-id="element-262"></th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-200" data-id="element-263">
              {departments.map(dept => <tr key={dept.name} data-id="element-264">
                  <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900" data-id="element-265">
                    {dept.name}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap" data-id="element-266">
                    <div className="flex items-center" data-id="element-267">
                      <div className="w-full bg-gray-200 rounded-full h-2.5 mr-2" data-id="element-268">
                        <div className={`h-2.5 rounded-full ${dept.efficiency >= 95 ? 'bg-green-500' : dept.efficiency >= 85 ? 'bg-blue-500' : 'bg-yellow-500'}`} style={{
                      width: `${dept.efficiency}%`
                    }} data-id="element-269"></div>
                      </div>
                      <span className="text-sm font-medium" data-id="element-270">
                        {dept.efficiency}%
                      </span>
                      <span className={`ml-2 text-xs ${dept.trend > 0 ? 'text-green-500' : 'text-red-500'}`} data-id="element-271">
                        {dept.trend > 0 ? '+' : ''}
                        {dept.trend}%
                      </span>
                    </div>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500" data-id="element-272">
                    {dept.volume.toLocaleString()}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500" data-id="element-273">
                    {dept.processingTime}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-blue-500" data-id="element-274">
                    <a href="#" data-id="element-275">View Details</a>
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>
      </div>
    </div>;
};